<template>
	<SOSlotBase>
		<template v-slot:title-bar>
			<SOTitleBar
				:page-title="'Playground: Input'"
				:type="'back'"
			/>
		</template>

		<template v-slot:content>
			<PlaygroundInputReguler/>
			<PlaygroundInputNominal/>
			<PlaygroundTextarea/>
			<PlaygroundCheckbox/>
			<PlaygroundRadio/>
			<PlaygroundSelect/>
			<PlaygroundInputDate/>
			<PlaygroundInputTelp/>
		</template>
	</SOSlotBase>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";

import SOTitleBar from "@/so-components/global/ui/SOTitleBar";

import PlaygroundInputReguler from "@/views/playground/input/PlaygroundInputReguler";
import PlaygroundInputNominal from "@/views/playground/input/PlaygroundInputNominal";
import PlaygroundTextarea from "@/views/playground/input/PlaygroundTextarea";
import PlaygroundCheckbox from "@/views/playground/input/PlaygroundCheckbox";
import PlaygroundRadio from "@/views/playground/input/PlaygroundRadio";
import PlaygroundSelect from "@/views/playground/input/PlaygroundSelect";
import PlaygroundInputDate from "@/views/playground/input/PlaygroundInputDate";
import PlaygroundInputTelp from "@/views/playground/input/PlaygroundInputTelp";

export default {
	name: "PlaygroundInput",
	components: {
		SOSlotBase,

		SOTitleBar,
		PlaygroundInputReguler,
		PlaygroundInputNominal,
		PlaygroundTextarea,
		PlaygroundCheckbox,
		PlaygroundRadio,
		PlaygroundSelect,
		PlaygroundInputDate,
		PlaygroundInputTelp,
	},

}
</script>